import type { PageLoad } from "./$types";

export const prerender = true;

export const load: PageLoad = () => {
  return {
    title: "Featured examples | Modal Docs",
    ogTitle: "Featured examples",
    ogDescription:
      "How to run LLMs, Stable Diffusion, data-intensive processing, computer vision, audio transcription, and other tasks on Modal.",
  };
};
